import gql from "graphql-tag";

export const CREATE_SHOP_SAMPLE = gql`
  mutation createShopSample($force: Boolean) {
    createShopSample(force: $force) {
      id
    }
  }
`;
